<div class="col full-height layout-column">

  <div class="flex layout-column dndList overflow-auto margin-top-5"
       cdkDropList
       [cdkDropListData]="tasks"
       id="{{route.id}}"
       [cdkDropListDisabled]="!!isLoading || route.isBlockedByUser"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">

    <app-route-editable-list-item *ngFor="let task of tasks;let index = index"
                                  [task]="task"
                                  [index]="index + 1"
                                  [route]="route"
                                  cdkDrag
                                  [cdkDragDisabled]="task.taskType === TaskType.Internal || !!isLoading || route.isBlockedByUser"
                                  [cdkDragData]="task">

    </app-route-editable-list-item>

  </div>
</div>
